
import { Component, Prop, Vue } from "vue-property-decorator";

import EditIcon from "@/components/icons/EditIcon.vue";
import RemoveIcon from "@/components/icons/RemoveIcon.vue";

@Component({
  components: {
    EditIcon,
    RemoveIcon,
  },
})
export default class CardContainer extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, default: undefined }) readonly subtitle?: string;

  get buttonClasses(): string {
    return "-ml-px w-0 flex-1 flex cursor-pointer focus:outline-none relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm leading-5 text-gray-700 font-medium rounded-br transition ease-in-out duration-150 hover:bg-cool-gray-50 border-l border-r border-t border-b border-gray-200 disabled:text-gray-500 disabled:bg-gray-200 disabled:cursor-default";
  }
}
